import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const ScrollIndicator = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  
  useEffect(() => {
    const updateScrollProgress = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
    };
    
    window.addEventListener('scroll', updateScrollProgress);
    return () => window.removeEventListener('scroll', updateScrollProgress);
  }, []);
  
  return (
    <div className="fixed right-8 top-1/2 transform -translate-y-1/2 z-40 hidden lg:block">
      <div className="relative h-48 w-1 bg-gray-300 rounded-full">
        <motion.div 
          className="absolute top-0 left-0 w-full bg-secondary rounded-full"
          style={{ scaleY: scrollProgress / 100, originY: 0 }}
          animate={{ scaleY: scrollProgress / 100 }}
          transition={{ duration: 0.2 }}
        />
      </div>
    </div>
  );
};

export default ScrollIndicator;